<app-view-title Title="{{ 'Intellitrailer.Booking.UnConfirmedBooking.TitleMyBooking' | translate : 'My booking' }}" [isPrimaryColor]="true"></app-view-title>

<view-content [centered]="true">
  @if(booking) {
  <app-card>
    <app-rental-box [booking]="booking" [hasLock]="hasLock" [allowUnmanned]="allowUnmanned" [isNuwiel]="isNuwiel" [isPickup]="true" (rentalAction)="recieveRentalAction($event)"></app-rental-box>
  </app-card>
  }

  @if(booking && !booking.IsOneWay && !tooFarAway && !tooEarly){
  <div class="link" (click)="cantFindTrailer()"> {{ 'Intellitrailer.Rental.BookingInfo.btnMyTrailerInstHere' | translate : 'My trailer isn´t here.' }}</div>
  }

 </view-content>

